module.exports = __webpack_public_path__ + "img/Group_127997@2x.4dbe9359.png";